module.exports = __webpack_public_path__ + "img/logo-utu-crop.2c3a2604.png";